import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { config } from '../../Constants';
import global from '../global';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import { Link } from 'react-router-dom';
import { Card, Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';
import { Layout } from '../Layout';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import queryString from 'query-string';
import download from 'downloadjs';
import Select from 'react-select';
import { getYearOptions } from '../../utils/yearUtil';

const expandRow = {
    renderer: row => (
        <div>
            <p className="m-t-10">{`DP ID: ${row.NAME_CSV}`}</p>
        </div>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true

};

const yearoptions = getYearOptions();
export class Dashboard extends Component {


    constructor(props) {
        super(props);
        this.state = {
            //selectedyear: '',
            //    yearOptions: [
            //        { value: '2025-2026', label: '2025-2026' },
            //        { value: '2024-2025', label: '2024-2025' },
            //        { value: '2023-2024', label: '2023-2024' }
            //    ],
            showYearModal: false,
            selectedYear: null,
            selectedRow: null,
            showCookieModal: false,
            PendingCount: 0,
            CompletedCount: 0,
            NRCount: 0,
            ORCount: 0,
            RemitterLogo: 'client-logo.png',
            RemitterStyle: '80%',
            divLogin: true,
            loading: false,
            showDecModal: false,
            showLoginDecModal: false,
            showCompDecModal: false,
            showNRDecModal: false,
            PendingDecList: [],
            columns: [
            {
                dataField: 'RemitterName',
                text: 'Listed Company Name',
                headerAlign: 'center',
                sort: true,

            },
            //{
            //    dataField: 'EmailID',
            //    text: 'Email',
            //    headerAlign: 'center',
            //    sort: true,

            //},
            {
                dataField: 'PAN',
                text: 'PAN',
                headerAlign: 'center',
                sort: true,
            },

                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
            {
                dataField: 'DPID',
                text: 'DP ID / Folio ID',
                headerAlign: 'center',
                sort: true,

            },

            //{
            //    dataField: 'FinancialYear',
            //    text: 'Financial Year',
            //    headerAlign: 'center',
            //    align: 'center',
            //    sort: true,
            //},
            {
                dataField: "Fill",
                text: "Fill Form",
                headerAlign: 'center',
                align: 'center',
                formatter: (rowContent, row) => {
                    return (
                        <div>
                            <button className="btn btn-primary p-10"
                                
                                onClick={(e) => {
                                    e.preventDefault();
                                        this.setState({
                                            showYearModal: true,
                                            selectedRow: row
                                        });
                                }}

                               > <FontAwesomeIcon icon="pencil-alt" /> </button>
                        </div>
                    )
                }
            },
            ],
            CompDecList: [],
            columnsComp: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },
              
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,
                },

                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleEdit(row.filePath, row.FileName);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            NRDecList: [],
            columnsNR: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download Documents",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleNRDownload(row.ZipLoc, row.BeneficiaryName);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            ORDecList: [],
            columnsOR: [
                {
                    dataField: 'RemitterName',
                    text: 'Listed Company Name',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'BeneficiaryName',
                    text: 'Shareholder Name as per Trading Account',
                    headerAlign: 'center',
                    align: 'center',
                    sort: true,
                },
                {
                    dataField: 'ResidentType',
                    text: 'Resident Type',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'PAN',
                    text: 'PAN',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: 'DPID',
                    text: 'DP ID / Folio ID',
                    headerAlign: 'center',
                    sort: true,

                },
                {
                    dataField: "Download",
                    text: "Download Documents",
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (rowContent, row) => {
                        return (
                            <div>
                                <button className="btn btn-primary p-10"
                                    onClick={e => {
                                        e.persist();
                                        Dashboard.handleNRDownload(row.ZipLoc, row.BeneficiaryName);
                                    }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                            </div>
                        )
                    }
                },
            ],
            AssignmentCode: -1,
            IsLogin: 0,
            URL: config.url.Web_URL,
            isResidentVisible: "none",
            isNonResidentVisible: "none",
            isOtherResidentVisible: "none",
            ShareholderType: "",
            IsForm121OnlyActive: '0',
            selectedyear: ''
        };

        const parsed = queryString.parse(window.location.search);
        this.state.AssignmentCode = window.atob(parsed['AC']);
        this.state.flag = window.atob(parsed['flag']);

        this.initialState = this.state;
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage

    }

    static handleEdit(rowContent1, rowContent2) {

        axios.get(global.Form15GH.DownloadDigiSignedPdfAPI + '?pdfLocation=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/pdf' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent2
                download(response.data, fileName, content)

            })
            .catch(error => {
                console.log(error);

            });
    }

    static handleNRDownload(rowContent1, rowContent2) {

        axios.get(global.Form15GH.DownloadNRDocumentsAPI + '?zipLocation=' + rowContent1,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/zip' },
                responseType: 'blob'
            })
            .then(response => {
                const content = response.headers['content-type'];
                const fileName = rowContent2 + '.zip'
                download(response.data, fileName, content)

            })
            .catch(error => {
                console.log(error);
            });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    componentDidMount() {

        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        IsLogin: response.data.IsLogin,
                    });

                }

            })
            .catch(error => {
                console.log(error);
            });

        axios.get(global.Resident.GetDematAccountCountAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag)
            .then(response => {
                //debugger
                if (response.data.Status) {

                    if (response.data.ShareholderType == "Resident") {
                        this.setState({
                            isResidentVisible: "block",
                            isNonResidentVisible: "none",
                            isOtherResidentVisible: "none"
                            
                        });
                    }
                    else if (response.data.ShareholderType == "Non-Resident") {
                        this.setState({
                            isResidentVisible: "none",
                            isNonResidentVisible: "block",
                            isOtherResidentVisible: "none"
                        });
                    }
                    else if (response.data.ShareholderType == "Other-Resident") {
                        this.setState({
                            isResidentVisible: "none",
                            isNonResidentVisible: "none",
                            isOtherResidentVisible: "block"
                        });
                    }

                    this.setState({
                        PendingCount: response.data.PendingCount,
                        CompletedCount: response.data.CompletedCount,
                        NRCount: response.data.NRCount,
                        ORCount: response.data.ORCount,
                        ShareholderType: response.data.ShareholderType,
                        IsForm121OnlyActive: response.data.IsForm121OnlyActive
                    });
                }
                else {
                    this.showNoti("Notification", "Unable to Load Demat Account Count. Kindly Try Again.", "danger");
                    return;
                }
            })
            .catch(error => {
                this.showNoti("Notification", error, "danger");
                return;
            });

    }

    toggleORModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            ORDecList: response.data.ORDecList,
                            showORDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            ORDecList: [],
                            showORDecModal: false
                        });

                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }

    }

    toggleNRModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            NRDecList: response.data.NRDecList,
                            showNRDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            NRDecList: [],
                            showNRDecModal: false
                        });

                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }

    }

    toggleCompDecModal = (e) => {

        if (this.state.IsLogin == 1) {

            e.preventDefault();

            axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag,
                { responseType: 'json' })
                .then(response => {
                    if (response.data.Status) {

                        this.setState({
                            CompDecList: response.data.CompDecList,
                            showCompDecModal: true
                        });
                    }
                    else {
                        this.setState({
                            CompDecList: [],
                            showCompDecModal: false
                        });

                        this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                        return;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }
        else {
            this.setState({
                showLoginDecModal: true
            });
        }
        
    }

    toggleLoginDecModal = (e) => {
        this.setState({
            showLoginDecModal: true
        });
    }

    handleLogin = (e) => {
        window.location.href = config.url.Web_URL + '/SignIn';
    };

    handleSignUp = (e) => {
        window.location.href = config.url.Web_URL + '/SignUp';
    };

    toggleDecModal = (e) => {

        e.preventDefault();

        axios.get(global.Resident.GetDematAccountDetailsAPI + '?AssignmentCode=' + this.state.AssignmentCode + '&flag=' + this.state.flag,
            { responseType: 'json' })
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        PendingDecList: response.data.PendingDecList,
                        CompDecList: response.data.CompDecList,
                        showDecModal: true
                    });
                }
                else {
                    this.setState({
                        PendingDecList: [],
                        CompDecList: [],
                        showDecModal: false
                    });

                    this.showNoti("Notification", "Unable to Load Demat Account Details. Kindly Try Again.", "danger");
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    modalClose = (e) => {

        this.setState({
            showDecModal: false,
            showLoginDecModal: false,
            showCompDecModal: false,
            showNRDecModal: false,
            showORDecModal: false
        });
    }
    handleYear(e) {
        if (e.value != undefined) {
            this.setState({ selectedyear: e.label });
        }
    }
    render() {
        let content = Layout.RenderNavMenu();

        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.PendingDecList.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columns}
                    data={this.state.PendingDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                    expandRow={expandRow}
                                   />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsComp = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.CompDecList.length
        };

        const contentTableComp = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsComp}
                    data={this.state.CompDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                    expandRow={expandRow}
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsNR = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.NRDecList.length
        };

        const contentTableNR = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsNR}
                    data={this.state.NRDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        const optionsOR = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.ORDecList.length
        };

        const contentTableOR = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="DPID"
                    columns={this.state.columnsOR}
                    data={this.state.ORDecList}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <BootstrapTable
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                    wrapperClasses="table-responsive"
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );

        return (
            <div>
                <ReactNotification />

                {/*PENDING DEC. MODAL*/}
                <Modal isOpen={this.state.showDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Resident Declaration Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(options)
                                    }
                                >
                                    {contentTable}
                                </PaginationProvider>
                            </Col>
                        </Row>
                       {/* {this.state.IsForm121OnlyActive === '0' && (*/}

                            <Modal isOpen={this.state.showYearModal} centered>
                                <ModalHeader>Select Tax Year</ModalHeader>

                                <ModalBody>
                                    <label className="required-field">Select Tax Year</label>

                                    <Select
                                        options={yearoptions}
                                        value={yearoptions.find(obj => obj.label === this.state.selectedYear)}
                                        onChange={(selected) => {
                                            this.setState({ selectedYear: selected.label });
                                        }}
                                    />
                                </ModalBody>

                                <ModalFooter>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            const row = this.state.selectedRow;

                                            if (!this.state.selectedYear) {
                                                //alert("Please select year");
                                                this.showNoti("Notification", "Please select year", "danger");
                                                return;
                                            }

                                            if (
                                                this.state.IsForm121OnlyActive === '0' &&
                                                this.state.selectedYear === '2025-2026'
                                            ) {
                                                window.location.href =
                                                    config.url.Web_URL + `/Resident/Form15GH` +
                                                    '?AC=' + window.btoa(this.state.AssignmentCode) +
                                                    '&DP=' + window.btoa(row.DPID) +
                                                    '&PN=' + window.btoa(row.PAN);
                                            } else {
                                                window.location.href =
                                                    config.url.Web_URL + `/Resident/Form121` +
                                                    '?AC=' + window.btoa(this.state.AssignmentCode) +
                                                    '&DP=' + window.btoa(row.DPID) +
                                                    '&PN=' + window.btoa(row.PAN) +
                                                '&FY=' + window.btoa(this.state.selectedYear);
                                            }
                                        }}
                                    >
                                        Submit
                                    </button>

                                    <button
                                        className="btn btn-dark m-l-10"
                                        onClick={() => this.setState({ showYearModal: false })}
                                    >
                                        Close
                                    </button>
                                </ModalFooter>
                            </Modal>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*COMPLETED DEC. MODAL*/}
                <Modal isOpen={this.state.showCompDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Resident Declaration Submitted Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(optionsComp)
                                    }
                                >
                                    {contentTableComp}
                                </PaginationProvider>
                            </Col>
                        </Row>
                        
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*NON Resident DEC. MODAL*/}
                <Modal isOpen={this.state.showNRDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseNRDec} charCode="X"><b>Non Resident Declaration Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                {/*<PaginationProvider*/}
                                {/*    pagination={*/}
                                {/*        paginationFactory(optionsNR)*/}
                                {/*    }*/}
                                {/*>*/}
                                {/*    {contentTableNR}*/}
                                {/*</PaginationProvider>*/}
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*Other Resident DEC. MODAL*/}
                <Modal isOpen={this.state.showORDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseORDec} charCode="X"><b>Other Resident Declaration Details</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                <PaginationProvider
                                    pagination={
                                        paginationFactory(optionsOR)
                                    }
                                >
                                    {contentTableOR}
                                </PaginationProvider>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                {/*LOGIN DEC MODAL*/}
                <Modal isOpen={this.state.showLoginDecModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader toggle={this.modalCloseCompDec} charCode="X"><b>Resident Declaration Details</b></ModalHeader>

                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                To access your previous records, <a onClick={this.handleLogin} className="dc-login">Login</a> or <a onClick={this.handleSignUp} className="dc-login">Sign up</a> to view your completed declarations.
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-dark m-l-10" type="button" onClick={this.modalClose}>Close</button>
                    </ModalFooter>
                </Modal>

                <div className="m-grid m-grid--hor m-grid--root m-page">
                    {content}
                    <div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="m-subheader " >
                                <div className="d-flex align-items-center">
                                    <div className="mr-auto">
                                        <h3 className="m-subheader__title ">
                                            {this.state.ShareholderType} Declaration
								        </h3>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col md={3} style={{ display: `${this.state.isResidentVisible}` }}>
                                    <a onClick={this.toggleDecModal} >
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Pending Declaration
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.PendingCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isResidentVisible}` }}>
                                    <a onClick={this.toggleCompDecModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h3 className="bold dc_title">
                                                            Completed Declaration
                                                        </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.CompletedCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isNonResidentVisible}` }}>
                                    <a onClick={this.toggleNRModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Non Resident Documents
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.NRCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={3} style={{ display: `${this.state.isOtherResidentVisible}` }}>
                                    <a onClick={this.toggleORModal}>
                                        <div className="card rounded align-content-center w-90 m-l-20">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h3 className="bold dc_title">
                                                        Other Resident Documents
                                                    </h3>
                                                </div>
                                                <div>
                                                    <h1 className="bold dc-count">{this.state.ORCount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </Col>
                            </Row>

                        </div>
                    </div>
                </div>

                
            </div>
        );
    }
}
